import { CssBaseline } from '@mui/material'

import { UIContextProvider } from './containers/ui-context'
import Root from './navigation/root'
import ReactQueryProvider from './providers/query'
import NotificationProvider from './providers/notification-provider'
import ThemeProvider from './providers/theme-provider'
import { ErrorWrapper } from './providers/error-wrapper'
import { UserSessionOnlineWrapper } from './containers'
import { ItemsRemoveConfirmProvider } from './providers/items-remove-confirm-provider'
import { DateProvider } from './providers/date-provider'
import { AppKitProvider } from './providers/web3-wagmi'
import './providers/i18n-provider'
import { LowBalanceNotificationProvider } from './providers/low-balance-notification-provider'
import { useDdRumSetup, useDynamicTitle } from './hooks'
import 'moment/min/locales'

import './app.css'

function App() {
  useDynamicTitle()
  
  useDdRumSetup()

  return (
    <ReactQueryProvider>
      <ThemeProvider>
        <CssBaseline />
        <UIContextProvider>
          <NotificationProvider>
            <ErrorWrapper>
              <UserSessionOnlineWrapper>
                <DateProvider>
                  <AppKitProvider>
                    <ItemsRemoveConfirmProvider>
                      <LowBalanceNotificationProvider>
                        <Root />
                      </LowBalanceNotificationProvider>
                    </ItemsRemoveConfirmProvider>
                  </AppKitProvider>
                </DateProvider>
              </UserSessionOnlineWrapper>
            </ErrorWrapper>
          </NotificationProvider>
        </UIContextProvider>
      </ThemeProvider>
    </ReactQueryProvider>
  )
}

export default App
